<template>
    <div>
        <b-row>
            <b-col sm="6">
                <span class="productoNom">Producto A: <span class="productoNom">{{ producto1.nombre }}</span></span>
            </b-col>
            <b-col sm="6">
                <span class="productoNom">Producto B: <span class="productoNom">{{ producto2.nombre }}</span></span>
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col sm="12">
                <strong>Naciones Unidas</strong>
            </b-col>
            <b-col sm="6" class="mt-3">
                <b-img 
                    v-if="producto1.imagen_principal"
                    fluid
                    :src="producto1.imagen_principal"
                    :alt="producto1.riesgo_principal"
                    class="icon-UNSga"
                />
                <b-img 
                    v-if="producto1.imagen_secundario"
                    fluid
                    :src="producto1.imagen_secundario"
                    :alt="producto1.riesgo_secundario"
                    class="icon-UNSga"
                />
                <b-img 
                    v-if="producto1.imagen_secundario1"
                    fluid
                    :src="producto1.imagen_secundario1"
                    :alt="producto1.riesgo_secundario1"
                    class="icon-UNSga"
                />
            </b-col>
            <b-col sm="6" class="mt-3">
                <b-img 
                    v-if="producto2.imagen_principal"
                    fluid
                    :src="producto2.imagen_principal"
                    :alt="producto2.riesgo_principal"
                    class="icon-UNSga"
                />
                <b-img 
                    v-if="producto2.imagen_secundario"
                    fluid
                    :src="producto2.imagen_secundario"
                    :alt="producto2.riesgo_secundario"
                    class="icon-UNSga"
                />
                <b-img 
                    v-if="producto2.imagen_secundario1"
                    fluid
                    :src="producto2.imagen_secundario1"
                    :alt="producto2.riesgo_secundario1"
                    class="icon-UNSga"
                />
            </b-col>
        </b-row>
        <b-row class="mt-2">
            <b-col sm="12">
                <strong>SGA</strong>
            </b-col>
            <b-col sm="6" class="mt-3">
                <div v-if="producto1.pictogramas.length">
                    <b-row>
                        <b-col v-for="(pictograma, index) in producto1.pictogramas" :key="index">
                            <b-img 
                                thumbnail
                                fluid
                                :src="pictograma.direccion"
                                :alt="pictograma.pictograma"
                                class="icon-UNSga"
                            ></b-img>
                        </b-col>
                    </b-row>              
                </div>
            <b-row v-else>
                <b-col>
                    <span>
                    SIN PICTOGRAMA
                    </span>
                </b-col>
                </b-row>
            </b-col>
            <b-col sm="6" class="mt-3">
                <div v-if="producto2.pictogramas.length">
                    <b-row>
                        <b-col v-for="(pictograma, index) in producto2.pictogramas" :key="index">
                            <b-img 
                                thumbnail
                                fluid
                                :src="pictograma.direccion"
                                :alt="pictograma.pictograma"
                                class="icon-UNSga"
                            ></b-img>
                        </b-col>
                    </b-row>              
                </div>
                <b-row v-else>
                    <b-col>
                    <span>
                        SIN PICTOGRAMA
                    </span>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'un-sga',
    data() {
        return {

        }
    },
    computed: {
        ...mapState('matrizCompatibilidad', [
            'producto1',
            'producto2'
        ])
    }
}
</script>
<style scoped>
.productoNom {
  font-size: 11pt;
}
.icon-UNSga {
    max-width: 125px; 
    max-height: 125px;
    margin-bottom: 2rem;
}
</style>